import React, { useContext, useEffect, useMemo, useState } from 'react'

import styled from 'styled-components';

import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { DEFAULT_TITLE, STATIC_URL } from '../lib/settings';
import { DataContext } from '../contexts/DataContext';
import PAGES from '../lib/pages';
import AppPage from '../layouts/AppPage';
import { PageNotFoundSection } from './PageNotFound';
import { metaTags } from '../lib/utils/metaTags';

export default function Author() {
  const { api } = useContext(AuthContext);
  const [author, setAuthor] = useState(null);
  const { setPiece } = useContext(DataContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getAuthor = async () => {
      setIsLoading(true);
      try {
        const slug = window.location.pathname.split('/').pop();
        const response = await api.getAuthor(slug);
        const author = response.data;
        setAuthor(author);
      } catch (error) {
      };
      setIsLoading(false);
    };
    getAuthor();
  }, [api]);

  const handlePieceClick = (piece) => {
    setPiece(piece);
  }

  const MetaTags = useMemo(() => {
    return metaTags({
      title: `${DEFAULT_TITLE} ${author ? `| ${author.full_name}` : ''}`,
      description: author?.bio,
      image: author?.image_path,
      url: `https://chimeras.world/authors/${author?.slug}`
    })
  }, [author]);

  return (
    <AppPage>
      {MetaTags}
      <AUTHOR>
        {!isLoading && author &&
        <>
          {author.image_path &&
            <IMAGE_CONTAINER className="image-container">
              <img src={`${STATIC_URL}/${author.image_path}`} alt={author.full_name} />
            </IMAGE_CONTAINER>
          }
          <LAYOUT>
            <BIO>
              <h2>{author.full_name}</h2>
              <p>{author.bio}</p>
            </BIO>
            <PIECES>
              <h3>Тексты:</h3>
              <ul>
                {author.pieces?.map((piece, index) => (
                  <li key={index}>
                    <Link 
                      to={`${PAGES.pieces}/${piece.id}`}
                      onClick={() => handlePieceClick(piece)}
                      className='link'>{piece.title}</Link>
                  </li>
                ))}
              </ul>
            </PIECES>
          </LAYOUT>
        </>}
      </AUTHOR>
      {!isLoading && !author && <PageNotFoundSection />}
    </AppPage>
  )
}

const IMAGE_CONTAINER = styled.div`
  width: 56%;

  & img {
    width: 100%;
    height: auto;
  }

  @media (min-width: 768px) {
    width: 30%;

    & .image-container  img {
      width: auto;
      max-height: 11.5rem;
    }
  }
`;

const LAYOUT = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;

  @media (min-width: 768px) {
    flex-direction: row;  
    gap: 80px;
  }
`;


const BIO = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  & h2 {
    font-size: 1.125rem;
    font-weight: 700;
    font-family: var(--primary-font);
  }

  & p {
    font-size: 1rem;
    font-weight: 400;
    font-family: var(--secondary-font);
  }

  @media (min-width: 768px) {
    width: 30%;

    & .image-container  img {
      width: auto;
      max-height: 11.5rem;
    }
  }
`;

const PIECES = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  font-family: var(--primary-font);

  & h3 {
    font-size: 1rem;
    font-weight: 500;
  }

  & ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  & li .link {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 200%;
    text-decoration: none;
    color: black;
  }

  & li .link:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;


const AUTHOR = styled.div`
  padding: 50px 20px 0 20px;

  display: flex;
  flex-direction: column;
  gap: 60px;

  @media (min-width: 768px) {
    padding: 20px 50px 0 50px;
  }
`;
